var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoOnSiteSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_219_173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4 14.99H26.29C33.83 14.99 40.01 21.16 40.01 28.71V39.17H26.12C18.58 39.17 12.4 33 12.4 25.45V14.99Z",
    fill: "#00DD39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.79 45.94H57.43C55.5 45.94 53.91 44.36 53.91 42.42V35.3H62.79V35.21C62.79 30.37 58.83 26.42 54 26.42H46.88V45.85H15.04V54.73H18.56C18.56 57.63 20.93 60.01 23.84 60.01C26.75 60.01 29.12 57.64 29.12 54.73H30.88C30.88 57.63 33.25 60.01 36.16 60.01C39.07 60.01 41.44 57.64 41.44 54.73H48.47C48.47 57.63 50.84 60.01 53.75 60.01C56.66 60.01 59.03 57.64 59.03 54.73H62.55V45.94H62.81H62.79Z",
    fill: "#004E2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_219_173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnSiteSimple);
export default __webpack_public_path__ + "static/media/LogoOnSiteSimple.3fa6eb30f9ad422c27d338f5db6f2e68.svg";
export { ForwardRef as ReactComponent };